import { call, put, select } from 'redux-saga/effects';

import {
  setOrganizationDetails,
  setPaymentSources,
  setPaymentSourcesError,
} from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getPaymentSources() {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA3
  }/${organizationId}/billing/payment-sources`;

  try {
    yield put(setPaymentSourcesError(false));
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });

    if (success && !error) {
      const { paymentSources = [], orgType } = result;
      yield put(
        setPaymentSources(paymentSources === null ? [] : paymentSources),
      );
      if (orgType) {
        yield put(setOrganizationDetails({ orgType }));
      }
    } else {
      yield put(setPaymentSourcesError(true));
    }
  } catch (e) {
    console.error(e);
  }
}
